// Gap kept between a menu and the viewport edge.
export const VIEWPORT_PADDING_PX = 8

const SIDE_BELOW = 'bottom'
const SIDE_ABOVE = 'top'

function pickSide(menuHeight, spaceBelow, spaceAbove) {
  if (menuHeight <= spaceBelow) {
    return SIDE_BELOW
  }
  if (menuHeight <= spaceAbove || spaceAbove > spaceBelow) {
    return SIDE_ABOVE
  }
  return SIDE_BELOW
}

/**
 * Popper modifier for `fixed` menus, which the page cannot be scrolled to reveal (AP-13546).
 * Opens below the toggle when the menu fits there, otherwise above when it fits there, otherwise
 * on the side with more room. The height is capped to that side so the menu scrolls inside itself
 * instead of running off screen. Replaces Popper's `flip`, which keeps the preferred side even
 * when it has the least room.
 */
export const fitMenuToViewport = {
  name: 'fitMenuToViewport',
  enabled: true,
  phase: 'main',
  fn({ state }) {
    const menu = state.elements.popper
    const toggleRect = state.elements.reference.getBoundingClientRect()
    const spaceBelow = window.innerHeight - toggleRect.bottom - VIEWPORT_PADDING_PX
    const spaceAbove = toggleRect.top - VIEWPORT_PADDING_PX
    // Full height including borders. `scrollHeight` ignores any cap applied by a previous update.
    const fullHeight = menu.scrollHeight + menu.offsetHeight - menu.clientHeight
    const side = pickSide(fullHeight, spaceBelow, spaceAbove)
    const availableHeight = side === SIDE_BELOW ? spaceBelow : spaceAbove
    const height = Math.max(Math.min(fullHeight, availableHeight), 0)

    const [currentSide, ...alignment] = state.placement.split('-')
    // Popper measured the menu before this modifier ran. Re-run it with the chosen side and the
    // capped height, so a menu opening above is placed by the height it will actually have.
    if (currentSide !== side || state.rects.popper.height !== height) {
      /* eslint-disable no-param-reassign */
      state.placement = [side, ...alignment].join('-')
      state.rects.popper = { ...state.rects.popper, height }
      state.reset = true
      /* eslint-enable no-param-reassign */
      return
    }

    // eslint-disable-next-line no-param-reassign
    state.styles.popper = { ...state.styles.popper, maxHeight: `${height}px` }
  },
}
